import classNames from 'classnames';
import { IWatchlistable } from 'src/components/filmwebid/withWatchlistState';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import styles from './WatchlistActionButton.module.css';

//#region [Props]
type WatchlistActionButtonProps = {
	className?: string;
	hideLabel?: boolean;
} & IWatchlistable;
//#endregion

//#region [Component]
export default function WatchlistActionButton({ className, isWatchlisted, onWatchlistClick, hideLabel = false }: WatchlistActionButtonProps) {
	return <button className={classNames(styles.SButton, className)} onClick={onWatchlistClick} title='Legg filmen i huskelisten'>
		<WatchlistSvg className={styles.SWatchlistSvg} selected={isWatchlisted} /> {!hideLabel && <span className={styles.SWatchListLabel}>Watchlist</span>}
	</button>;
}
//#endregion

//#region [Styles]
// styles migrated to WatchlistActionButton.module.css
//#endregion
